import cn from "classnames"
import { ReactNode } from "react"
import { Link } from "react-router-dom"

import styles from "./styles.module.scss"

import { getRootPath } from "utils/utils"

interface Props {
    children: ReactNode
    className?: string
    target?: HTMLAnchorElement["target"]
    url?: string
}

export function HeaderLogo({ children, className, target, url }: Props) {
    return (
        <Link className={cn(styles.logo, className)} to={url || getRootPath()} target={target}>
            {children}
        </Link>
    )
}
